// axiosInstance.js
import axios from "axios";
import { store } from "../../store/store";
import { setupCache } from "axios-cache-interceptor";
import { clearUserData } from "../../store/slices/userSlice";
import { manualLogout, setClearAuth } from "../../store/slices/authSlice";

const API_BASE_URL = "https://scooteruat-api.tnq.co.in/api"
// const API_BASE_URL = "http://localhost:4000/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

const axiosCached = setupCache(api, {
  ttl: 1000 * 60 * 5,
  interpretHeader: false,
  methods: [],
});

// Request Interceptor
api.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.auth.accessToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response Interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized: Token expired or invalid");
    }
    if (
      error.response?.status === 401 &&
      error?.response?.data?.message === "User account is inactive"
    ) {
      window.location.href = error?.response?.data?.redirect;
      store.dispatch(setClearAuth());
      return;
    }
    return Promise.reject(error);
  }
);

// Generic API request function with optional headers
const apiRequest = async (
  method,
  endpoint,
  data = {},
  params = {},
  customHeaders = {},
  invalidateCache = false,
  loginTrue = "No"
) => {
  try {
    if (loginTrue === "No") {
      try {
        await api.get("/auth/expired");
      } catch (err) {
        if (err.response?.status === 401) {
          store.dispatch(clearUserData());
          store.dispatch(manualLogout());
          throw new Error("Token expired. Please log in again.");
        }
        throw err;
      }
    }

    const response = await api({
      method,
      url: endpoint,
      data,
      params,
      headers: { ...api.defaults.headers, ...customHeaders },
    });

    // Invalidate cache for GETs after mutating operations
    if (
      ["put", "patch", "delete"].includes(method.toLowerCase()) ||
      invalidateCache
    ) {
      axiosCached.storage.clear();
    }

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        error.response?.data?.error ||
        "API request failed"
    );
  }
};

export default apiRequest;
export { API_BASE_URL };
